{
    "authenticated": true,
    "firstName": "Jožko",
    "lastName": "Mrkvička",
    "prefferedAgent": {
        "agentId": null,
        "agentNo": null,
        "agentName": null,
        "agentStatus": null,
        "agentChannel": null,
        "agentMobilAgn": null,
        "agentEmailAgn": null,
        "agentUrl": null,
        "agentItemId": null,
        "dateEnd": null,
        "resultId": 1
    },
    "locale": "sk",
    "lastLogin": "2022-06-16T16:55:24+02:00",
    "SetPrefferedAgentPopup": true,
    "agentSource": 2,
    "role": 3,
    "vatNumber": "12345678",
    "isAdmin": true,
    "profileUrl": "http://accounttest.allianz.sk"
}